import theme_icons from '../../icons.js';
import { MediaUploaderGeneric } from '../../components/image-picker-generic.js';
import { AdderGeneric } from '../../components/adder-generic.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { useEffect } = wp.element;
const { RichText, InspectorControls } = wp.blockEditor;
const { Button, PanelBody, TextControl, ToggleControl } = wp.components;


 const reviewsbottom = {
	title: 'Reviews Card Slider',
	icon: theme_icons.greenheart,
    category: 'greenheart',
    supports: {
      align: ['alignwide', 'alignfull']
  },
    //attributes
    attributes: {
        isAdding: {
          type: 'boolean',
          default: false
        },
        isEditing: {
          type: 'number',
          default: -1
        },
        name: {
          type: 'string',
          default: ''
        },
        text: {
          type: 'string',
          default: ''
        },
        icon: {
          type: 'object',
          default: {}
        },
        photo: {
          type: 'object',
          default: {}
        },
        linkText: {
          type: 'string',
          default: ''
        },
        linkUrl: {
          type: 'string',
          default: ''
        },
        cards: {
          type: 'array',
          default: []
        },
        currentId: {
          type: 'number',
          default: 0
        },
        isBlank: {
            type: 'boolean',
            default: false
        }
    },
    
    edit({ attributes, setAttributes }) {
        const { isAdding, isEditing, name, text, icon, photo, linkText, linkUrl, cards, currentId, isBlank } = attributes;
    
        useEffect(() => {
          let i = getNextId();
          setAttributes({ currentId: i });
        }, []);
    
        const getNextId = () => {
          let i = 1;
          while (cards.filter((card) => card.id === i).length > 0) { i++; }
          return i;
        }
    
        function onNameChange(newName) {
          setAttributes({ name: newName });
        }
    
        function onTextChange(newText) {
          setAttributes({ text: newText });
        }
    
        function onIconChange(newIcon) {
          setAttributes({ icon: newIcon });
        }
    
        function onPhotoChange(newPhoto) {
          setAttributes({ photo: newPhoto });
        }
    
        function onLinkTextChange(newLinkText) {
          setAttributes({ linkText: newLinkText });
        }
    
        function onLinkUrlChange(newLinkUrl) {
          setAttributes({ linkUrl: newLinkUrl });
        }
    
        const resetAddCardForm = () => {
          let nextId = getNextId();
          setAttributes({ 
            isAdding: false, 
            isEditing: -1, 
            name: '', 
            text: '', 
            icon: {}, 
            photo: {},
            linkText: '',
            linkUrl: '' 
          });
        }
    
        const addCard = () => {
          const nextId = getNextId();
          setAttributes({
            currentId: nextId,
            isAdding: true,
            isEditing: -1,
          });
        };
    
        const editCard = (id) => {
          const card = cards.find((card) => card.id === id);
          setAttributes({
            name: card.name,
            text: card.text,
            icon: card.icon,
            photo: card.photo,
            linkText: card.linkText,
            linkUrl: card.linkUrl,
            currentId: id,
            isEditing: id,
          });
        };
    
        const saveCard = () => {
          const newCard = {
            name: name,
            text: text,
            icon: icon,
            photo: photo,
            linkText: linkText,
            linkUrl: linkUrl,
            id: currentId,
          };
    
          const cardIndex = cards.findIndex((card) => card.id === currentId);
          let newCards;
    
          if (cardIndex !== -1) {
            newCards = [...cards];
            newCards[cardIndex] = newCard;
          } else {
            newCards = [...cards, newCard];
          }
    
          setAttributes({ cards: newCards });
          resetAddCardForm();
        };
    
        const deleteCard = (id) => {
          const newCards = cards.filter((card) => card.id !== id);
          setAttributes({ cards: newCards });
        }
    
        const moveCard = (index, direction) => {
          if (
            (direction === 'left' && index === 0) || 
            (direction === 'right' && index === cards.length - 1)
          ) {
            return;
          }
    
          const newCards = [...cards];
          const newIndex = direction === 'left' ? index - 1 : index + 1;
          [newCards[index], newCards[newIndex]] = [newCards[newIndex], newCards[index]];
          setAttributes({ cards: newCards });
        };
    
        const displayCards = () => {
          return (
            <div className="cards row">
              {cards.map((card, index) => {
                return (
                  <div key={index} className="col">
                    <div className="block card">
                      <div className="card-icons">
                        {card.icon.mediaUrl && 
                          <img className="card-company-icon" src={card.icon.mediaUrl} alt="Company icon" />
                        }
                      </div>
                      <div className="card-body">
                        <div className="card-text">{card.text}</div>
                        <div className="reviewer-info">
                          {card.photo.mediaUrl && 
                            <img className="reviewer-photo" src={card.photo.mediaUrl} alt={`${card.name} photo`} />
                          }
                          <h3 className="reviewer-name">{card.name}</h3>
                          {card.linkUrl && 
                            <a href={card.linkUrl} target="_blank" rel="noopener noreferrer">{card.linkText}</a>
                          }
                        </div>
                      </div>
                      <div className="card-controls">
                        <Button className="button secondary" onClick={() => deleteCard(card.id)}>Delete</Button>
                        <Button className="button primary" onClick={() => editCard(card.id)}>Edit</Button>
                        <Button 
                          className="button order-button"
                          onClick={() => moveCard(index, 'left')}
                          disabled={index === 0}
                        >
                          ⬅️
                        </Button>
                        <Button 
                          className="button order-button"
                          onClick={() => moveCard(index, 'right')}
                          disabled={index === cards.length - 1}
                        >
                          ➡️
                        </Button>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          )
        }
    
        return ([
            <InspectorControls>
            <PanelBody title="Card Settings">
                <p><strong>Open in New Tab?</strong></p>
                <ToggleControl
                    label="Open link in a new tab"
                    checked={isBlank}
                    onChange={(newValue) => setAttributes({ isBlank: newValue })}
                />
            </PanelBody>
            </InspectorControls>,
            <div className="rbt-testimonial-cards">
                {(isAdding || isEditing > 0) ?
                <div className="rbt-testimonial-cards-form" style={{maxWidth:"300px", margin:"0 auto"}}>
                    <div className="card-wrap">
                    <div className="image-upload-areas">
                        <div className="icon-area" style={{position:"relative"}}>
                        <h4>Company Icon</h4>
                        <MediaUploaderGeneric 
                            photo={icon}
                            updateImage={onIconChange}
                            buttonPosition="right"
                            isContain={true}
                        />
                        </div>
                        <div className="photo-area" style={{position:"relative"}}>
                        <h4>Reviewer Photo</h4>
                        <MediaUploaderGeneric 
                            photo={photo}
                            updateImage={onPhotoChange}
                            buttonPosition="right"
                        />
                        </div>
                    </div>
                    <div className="name-area">
                        <RichText
                        tagName="h3"
                        className="reviewer-name"
                        value={name}
                        onChange={onNameChange}
                        placeholder="Reviewer Name"
                        />
                    </div>
                    <div className="text-area">
                        <RichText
                        tagName="p"
                        value={text}
                        onChange={onTextChange}
                        placeholder="Testimonial Text"
                        />
                    </div>
                    <div className="link-area">
                        <TextControl
                        label="Link Text"
                        value={linkText}
                        onChange={onLinkTextChange}
                        placeholder="e.g., View Case Study"
                        />
                        <TextControl
                        label="Link URL"
                        value={linkUrl}
                        onChange={onLinkUrlChange}
                        placeholder="https://..."
                        />
                    </div>
                    </div>
                    {name.length > 0 && text.length > 0 && 
                    <Button className="button primary" onClick={saveCard}>Save Card</Button>
                    }
                    <Button className="button secondary" onClick={resetAddCardForm}>Cancel</Button>
                </div>
                :
                <div className="rbt-testimonial-cards-cards">
                    {displayCards()}
                    <AdderGeneric onAdd={addCard} />
                </div>
                }
            </div>
        ]);
    },
    
    save({ attributes }) {
      const { cards, isBlank } = attributes;
  
      // Define SVG markup for quote open and quote close
      const quoteOpen = `
        <svg height="800px" width="800px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
          viewBox="0 0 512 512"  xml:space="preserve">
        <g>
          <path fill="currentColor" d="M119.472,66.59C53.489,66.59,0,120.094,0,186.1c0,65.983,53.489,119.487,119.472,119.487
            c0,0-0.578,44.392-36.642,108.284c-4.006,12.802,3.135,26.435,15.945,30.418c9.089,2.859,18.653,0.08,24.829-6.389
            c82.925-90.7,115.385-197.448,115.385-251.8C238.989,120.094,185.501,66.59,119.472,66.59z"/>
          <path fill="currentColor" d="M392.482,66.59c-65.983,0-119.472,53.505-119.472,119.51c0,65.983,53.489,119.487,119.472,119.487
            c0,0-0.578,44.392-36.642,108.284c-4.006,12.802,3.136,26.435,15.945,30.418c9.089,2.859,18.653,0.08,24.828-6.389
            C479.539,347.2,512,240.452,512,186.1C512,120.094,458.511,66.59,392.482,66.59z"/>
        </g>
        </svg>
      `;
  
      const quoteClose = `
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="-1.5 -1.5 27 27">
            <path fill="none" stroke="currentColor" stroke-width="1.5" d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h9.983zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z"/>
        </svg>
      `;
  
      return (
          <div className="block">
              <div className="cards row" data-process="doOverflowControls">
                  {cards.map((card, index) => (
                      <div key={index} className="col"> 
                          <div className="card testimonial-card shadow">
                              {card.icon.mediaUrl && 
                                  <div className="card-icons">
                                      <img 
                                          className="card-company-icon" 
                                          src={card.icon.mediaUrl} 
                                          alt="Company icon"
                                          loading="lazy"
                                      />
                                  </div>
                              }
                              <div className="card-body">
                                  <div className="reviewer-info">
                                      {card.photo.mediaUrl && 
                                      <div className="reviewer-photo-wrap">
                                          <img 
                                              className="reviewer-photo" 
                                              src={card.photo.mediaUrl} 
                                              alt={`${card.name} photo`}
                                              loading="lazy"
                                          />
                                      </div>
                                      }
                                      
                                      <div className="quotewrap">
                                          {/* Prepend the quote open */}
                                          <span className="quote-open"
                                              dangerouslySetInnerHTML={{ __html: quoteOpen }}
                                          />
                                          <p className="card-text">{card.text}</p>
                                          {/* Optional - Append the quote close */}

                                          {/* <span className="quote-close"
                                              dangerouslySetInnerHTML={{ __html: quoteClose }}
                                          /> */}

                                      </div>
                                      <h3 className="reviewer-name">{card.name}</h3>
                                      {card.linkUrl && isBlank &&
                                          <a className="review-link"
                                              href={card.linkUrl} 
                                              target="_blank" 
                                              rel="noopener noreferrer"
                                          >
                                              {card.linkText}
                                          </a>
                                      }
                                      {card.linkUrl && !isBlank &&
                                          <a className="review-link" href={card.linkUrl}>
                                              {card.linkText}
                                          </a>
                                      }
                                  </div>
                              </div>
                          </div>
                      </div>
                  ))}
              </div>
          </div>
      );
    }
};
registerBlockType('rbt/reviewsbottom', reviewsbottom);
export default reviewsbottom;